import React, { Component } from 'react';
import CustomSlider from '../../common/custom-slider';
import { min, max } from 'lodash';

import RecommendedArticleBox from '../recommended-article-box/recommended-article-box';
import TagsFiltersBar from '../../common/tags-filters-bar/tags-filters-bar';
import LoadingIndication from '../../common/loading-indicator';
import LevelsFilterBar from '../../common/levels-filter-bar';
import articleTagsService from '../../../services/article-tags/article-tags';
import AnimatedWrapper from '../../core/animated-wrapper';
import shareService from '../../../services/share';
import recommendedArticlesService from '../../../services/recommended-articles';
import SmartAd from '../../ads/smart-ad';

import './recommended-articles.css';

class RecommendedArticles extends Component {
  constructor(props) {
    super(props);

    const tags = articleTagsService.getRecommendationsTags();

    this.state = {
      isLoading: true,
      isError: false,      
      articles: [],
      shownArticles: [],
      tags: tags,
      filterByTag: tags[0],
      filterByLevel: null
    };

    shareService.setupPage({
      title: "The Editor Recommendations"
    });     
  }

  componentDidMount() {
    recommendedArticlesService.getArticles()
      .then((articles) => {
        const { minMinutes, maxMinutes } = this._calcMinutesRange(articles);

        this.setState((prevState) => {
          const filterResults = this._filterArticles(articles, prevState.filterByTag.id, maxMinutes, prevState.filterByLevel);
          
          return {
            isLoading: false,
            isError: false,
            articles: articles,
            ...filterResults,
            filterByMinutes: maxMinutes,
            minMinutes: minMinutes,
            maxMinutes: maxMinutes
          };
        }); 
      })
      .catch(error => {
        console.error('RecommendedArticles::componentDidMount', error);
        this.setState({
          isLoading: false,
          isError: false
        });
      });
  }

  // shouldComponentUpdate(nextProps, nextState) {

  // }

  _getArticleMinutes(article) {
    const minutesString = article.readMinutes;
    if (!minutesString) {
      console.error(`RecommendedArticles::_getArticleMinutes missing read minutes for ${article._id}`);
      return 10;
    }
    
    return Number(minutesString.split(' ')[0]);
  }

  _getArticleLevel(article) {
    if (article.level === null || article.level === undefined) {
      console.error(`RecommendedArticles::_getArticleLevel missing level for ${article._id}`);
      return 1;
    }
    
    return Number(article.level);    
  }

  _calcMinutesRange(articles) {
    const minutes = articles.map(this._getArticleMinutes);

    return {
      minMinutes: min(minutes),
      maxMinutes: max(minutes)      
    }
  }

  _isArticleHasTag(article, tagId) {
    return article.tags.indexOf(tagId) !== -1;
  }

  _filterArticles(articles, tagId, minutes, level) {
    let filteredTagArticles = articles.filter((article) => {
      return this._isArticleHasTag(article, tagId);
    });
    
    let filteredArticles = filteredTagArticles.filter((article) => {
      return this._getArticleMinutes(article) <= minutes && 
        (level === null || this._getArticleLevel(article) === level);
    });

    return {
      filteredTagArticlesNum: filteredTagArticles.length,
      shownArticles: filteredArticles
    };
  }

  onTagFilterClick = (tag) => {
    this.setState((prevState) => {
      const filterResult = this._filterArticles(prevState.articles, tag.id, prevState.filterByMinutes, prevState.filterByLevel);
      
      return {
        filterByTag: tag,
        ...filterResult
      }
    });
  }

  // onClearTagFilterClick = () => {
  //   this.setState((prevState) => {
  //     return {
  //       filterByTag: null,
  //       shownArticles: this._filterArticles(prevState.articles, null, prevState.filterByMinutes)
  //     }
  //   });    
  // }

  onMinutesChange = (newMinutes) => {
    this.setState((prevState) => {
      const filterResult = this._filterArticles(prevState.articles, prevState.filterByTag.id, newMinutes, prevState.filterByLevel);
      
      return {
        filterByMinutes: newMinutes,
        ...filterResult
      };
    });
  };

  onLevelChange = (newLevel) => {
    this.setState((prevState) => {
      const filterResult = 
        this._filterArticles(prevState.articles, prevState.filterByTag.id, prevState.filterByMinutes, newLevel);
      
      return {
        filterByLevel: newLevel,
        ...filterResult
      };
    });
  };

  getArticlesPartJSX() {
    if (this.state.articles.length === 0) {
      return (
        <p>There is no recommendations</p>
      );
    }
    else {
      return this.state.shownArticles.map((article) => 
        <RecommendedArticleBox {...article} key={`recommended-articles-${article._id}`} />
      );
    }
  }

  render() {
    let extraJSX;
    
    if (this.state.isLoading) {
      extraJSX = (
        <LoadingIndication />
      );
    }
    else {
      extraJSX = (
        <div>
          <div className='minutes-custom-slider-container'>
            <div className='minutes-custom-slider'>
              <CustomSlider 
                step={1} 
                min={this.state.minMinutes} 
                max={this.state.maxMinutes}
                value={this.state.filterByMinutes}
                onChange={this.onMinutesChange} />
            </div>
          </div>

          <div className='levels-filter-bar-container'>
            <div className='levels-filter-bar-text'>Choose a level:</div> 
            <LevelsFilterBar onSelect={this.onLevelChange} />
          </div>          

          <p className='shown-articles-count'>
            Show {this.state.shownArticles.length} out of {this.state.filteredTagArticlesNum} recommendations for 
            <span className='selected-tag'>{this.state.filterByTag.text}</span>
            tag
          </p>
          
          <SmartAd />

          <div className='articles'>
            {this.getArticlesPartJSX()}
          </div>
        </div>
      );
    }

    return (
      <section className='regular-page recommended-articles-container'>
        <h3 className='page-title'>The Editor Recommendations</h3>
        <hr className='title-separator' />

        <TagsFiltersBar
          tags={this.state.tags}
          onFilterClick={this.onTagFilterClick}
          isAllOn={false} />

        {extraJSX}
      </section>
    );
  }
}

const AnimatedRecommendedArticles = AnimatedWrapper(RecommendedArticles);
export default AnimatedRecommendedArticles;